import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useCohortFlag } from './useCohortFlag'
import { selectMatchesState } from 'src/modules/reducers/matches'
import { teamShortNames } from 'src/constants/personalizationIds'
import { AnimatedCountdownTimer } from 'src/components/common/CountdownTimer'

export const useCountdownTest = (teamId, cohortFlag, isShowCountdown = false) => {
  const matches = useSelector(selectMatchesState)
  const countdownTimerValue = useCohortFlag(cohortFlag)
  const isCountdownWNetworks = countdownTimerValue === 'timer-w-networks'
  const isCountdownNoSubtitle = isShowCountdown || countdownTimerValue === 'timer-no-subtitle'
  const isCountdown = isShowCountdown || isCountdownWNetworks || isCountdownNoSubtitle
  const teamMatches = useMemo(() => {
    if (!teamId) return []

    return matches.list.filter((match) => {
      const teamsMetadata = match.data.program?.metadata?.teamsMetadata
      return (
        String(teamsMetadata?.homeTeam?.id) === String(teamId) ||
        String(teamsMetadata?.awayTeam?.id) === String(teamId)
      )
    })
  }, [matches.list, teamId])

  let matchCountdownTimer = null
  let matchTitle = null
  let pageTitle = null

  if (isCountdown && teamId) {
    if (teamMatches[0]) {
      const teamsMetadata = teamMatches[0].data.program?.metadata?.teamsMetadata
      const { homeTeam: homeTeamName, awayTeam: awayTeamName } = teamsMetadata || {}

      const getTeamDisplayName = (team) =>
        team.id && teamShortNames[team.id] ? teamShortNames[team.id] : team.name

      const homeTeam = getTeamDisplayName(homeTeamName)
      const awayTeam = getTeamDisplayName(awayTeamName)
      const isHomeTeam = String(homeTeamName?.id) === String(teamId)

      const primaryTeam = isHomeTeam ? homeTeam : awayTeam
      const opponentTeam = isHomeTeam ? awayTeam : homeTeam

      pageTitle = `Watch ${primaryTeam} vs ${opponentTeam} live`
      matchTitle = (
        <>
          Watch {primaryTeam} vs {opponentTeam} live
        </>
      )
      matchCountdownTimer = (
        <AnimatedCountdownTimer startTime={teamMatches[0].data.assets[0].accessRights.startTime} />
      )
    }
  }

  return {
    matchCountdownTimer,
    matchTitle,
    pageTitle,
    teamMatches,
    isCountdownWNetworks,
    isCountdownNoSubtitle,
    isCountdown,
  }
}
